module.exports = __webpack_public_path__ + "static/media/Rucochem.e1afd11c.webp";